export interface SubBrandFormShape {
  displayName: string;
}

export const defaultValues: SubBrandFormShape = {
  displayName: '',
};
